import React, { useContext } from 'react';
import styled from 'styled-components';

import Badge from 'kingpin/atoms/Badge';
import Typography from 'kingpin/atoms/Typography';
import Row from 'components/Common/Row';
import { MaintenanceModeContext } from 'contextProviders/SplashScreenProviders/UserAndAccountProviders/MaintenanceModeGate';

const BannerDiv = styled.div`
  flex-shrink: 0;
  width: 100%;
  padding: 8px 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  background-color: var(--color-badge-warning-bg);
  border-bottom: 1px solid var(--color-badge-warning-border);
`;

const BadgeWrapper = styled.div`
  flex-shrink: 0;
`;

// Not dismissible: shown for as long as maintenance mode is active.
const MaintenanceBanner = () => {
  const { bannerMessages } = useContext(MaintenanceModeContext);

  if (bannerMessages.length === 0) {
    return null;
  }

  return (
    <BannerDiv data-testid="maintenance-banner">
      {bannerMessages.map((m) => (
        <Row centerAlign key={m.key} style={{ gap: 8 }}>
          {m.isStaffSplashNotice && (
            // Badge is flex: 1, so contain it to keep it to its content width
            <BadgeWrapper>
              <Badge badgeType="Red" text="Only visible to FleetOps staff" />
            </BadgeWrapper>
          )}
          <Typography.Body type="Body 12">{m.message}</Typography.Body>
        </Row>
      ))}
    </BannerDiv>
  );
};

export default MaintenanceBanner;
